$(function(){
  $('form.form-auto-submit').each(function() {
      var $form = $(this);


      $form.find('select,input').on('change', () => {
          $form.trigger('submit');
      });

    //   $form.find('input').on('input', () => {
    //     $form.trigger('submit');
    // });
  });
});
